import React, { useState, useEffect } from "react";
import { Theme, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../components/custom-button";
import FormInput from "../components/form-input";
import { isElectron } from "../utils/platform";
import { useHistory, useRouteMatch } from "react-router-dom";
import { globalStore } from "../stores/global";
import axios from "axios";
import { t } from "../i18n";
import { useAuth } from "../services/auth-check";
import Language from "@material-ui/icons/Language";

import LangSelect from "../components/lang-select";
import GlobalStorage from "../utils/custom-storage";
import { API_V1 } from "../services/ihr-meet-api";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: "300px",
    maxWidth: "300px",
  },
}));

type SessionInfo = {
  password: string;
  confirmPassword: string;
};

const defaultState: SessionInfo = {
  password: "",
  confirmPassword: "",
};

function HomePage() {
  document.title = t(`home.short_title.title`);

  const { params } = useRouteMatch<{ link: any }>();

  const classes = useStyles();

  const history = useHistory();

  const [session, setSessionInfo] = useState<SessionInfo>(defaultState);

  const [required, setRequired] = useState<any>({} as any);

  //   window.addEventListener('keyup', event => {
  //     if (event.keyCode === 13) {
  //         this.callEvent()
  //     }
  // })

  const handleSubmit = () => {
    const lang =
      JSON.parse(localStorage.getItem("language") as string) === "en-US" ||
      JSON.parse(localStorage.getItem("language") as string) === "en"
        ? "en"
        : "ar";
    if (!session.password || !session.confirmPassword) {
      setRequired({ ...required, missingField: t("requiredField") });
      return;
    }
    if (session.password !== session.confirmPassword) {
      globalStore.showToast({
        type: "rtmClient",
        message: t("toast.passwordsDontMatch"),
      });
    } else {
      axios({
        method: "POST",
        url: `${API_V1}/reset-passwords/set-new-password`,
        headers: {
          "x-localization": lang,
        },
        data: {
          token: params?.link,
          password: session.password,
          password_confirmation: session.confirmPassword,
        },
      })
        .then(
          (response: any) => {
            history.push("/");
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.passwordChanged"),
            });
          },
          (error: any) => {
            if (error.response.data.errors.password) {
              globalStore.showToast({
                type: "rtmClient",
                message: error.response.data.errors.password,
              });
            } else {
              globalStore.showToast({
                type: "rtmClient",
                message: t("toast.passwordIsWrong", { reason: error.message }),
              });
            }
          }
        )
        .finally(() => {
          globalStore.stopLoading();
        });
    }
  };

  const [authorized, redirect] = useAuth("FORGET_PASSWORD");

  if (!authorized) {
    redirect();
    return null;
  }

  return (
    <>
      <div
        className={`flex-container forget-password-page  home-cover-web ${JSON.parse(
          localStorage.getItem("language") as string
        )}`}
      >
        <div className="logo mobile"></div>
        <div style={{ display: "contents" }}>
          <div className="logo"></div>
          <h2 style={{ color: "white", fontSize: 15 }}>
            {t("forgotPassword")}
          </h2>
          <div className="position-content flex-direction-column">
            <FormControl
              style={{ margin: "15px" }}
              className={classes.formControl}
            >
              <FormInput
                placeholder={t("newPassword")}
                value={session.password}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    password: val,
                  });
                }}
                type="password"
                requiredText={session.password ? "" : required.missingField}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <FormInput
                placeholder={t("newConfirmationPass")}
                value={session.confirmPassword}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    confirmPassword: val,
                  });
                }}
                type="password"
                requiredText={
                  session.confirmPassword ? "" : required.missingField
                }
              />
            </FormControl>
            <Button name={t("submit")} onClick={handleSubmit} />
          </div>
        </div>
      </div>
    </>
  );
}
export default React.memo(HomePage);
